module.exports = __webpack_public_path__ + "static/media/santa-rita.67b7a994.svg";